import { ReactNode } from 'react';
import { ThemeName } from './useTheme';
import { ThemeProvider as NextThemesProvider } from 'next-themes';

/**
 * WhiteLine theme provider.
 *
 * Wraps `next-themes` with brand defaults so the rest of the app can stay
 * agnostic of the underlying library. All colour tokens live in
 * `src/shared/styles/theme.css` and are swapped by toggling the `.dark`
 * / `.light` class on <html>.
 */
export function ThemeProvider({ children, forcedTheme }: { children: ReactNode; forcedTheme?: ThemeName }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      disableTransitionOnChange
      enableSystem
      forcedTheme={forcedTheme}
      storageKey="whiteline-theme"
      themes={['light', 'dark']}
    >
      {children}
    </NextThemesProvider>
  );
}